<ciao-form-field-date-input
  [formControlInput]="dateControl"
  [inputId]="inputId + 'date'"
  [label]="label"
></ciao-form-field-date-input>

<ngb-timepicker
  [formControl]="timeControl"
  [meridian]="true"
  size="small"
  [id]="inputId + 'time'"
></ngb-timepicker>
